const GTM_ID = 'GTM-M48VPBW';
const GA4_ID = 'G-DFR2E8QZFZ';
const GOOGLE_ADS_ID = 'AW-928952608';
const PRODUCTION_ENVIRONMENTS = ['prod', 'gprd'];

// GTM, GA4 and Google Ads are loaded only in production so that test data never reaches them.
export function loadGoogleTags(environment: string): void {
  if (PRODUCTION_ENVIRONMENTS.indexOf(environment) === -1) {
    return;
  }

  const w: any = window;
  const d = document;

  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const gtmScript = d.createElement('script');
  gtmScript.async = true;
  gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
  d.head.appendChild(gtmScript);

  const gtagScript = d.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
  d.head.appendChild(gtagScript);

  w.gtag = function() {
    w.dataLayer.push(arguments);
  };
  w.gtag('js', new Date());
  w.gtag('config', GA4_ID, { debug_mode: false });
  w.gtag('config', GOOGLE_ADS_ID);
}



// WEBPACK FOOTER //
// src/app/common/services/analytics/google-tags.loader.ts